<template>
  <form id="payment-form" @submit.prevent="submitHandler">
    <div id="payment-element"></div>
    <div id="payment-message" class="hidden"></div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { determine_locale } from "../../plugins/contentful";
import { countryCodeMappings } from "../../settings";
export default {
  props: ["stripe", "stripeOptions"],
  emits: ["stripe-payment", "stripe-form-change"],

  data: () => {
    return {
      stripeElement: undefined,
    };
  },
  computed: {
    ...mapGetters("billing", ["billing"]),
    ...mapGetters("checkout", ["writtenLanguage", "currencyIsoCode"]),
  },

  methods: {
    verifyCompletedForm(changeEvent) {
      this.$emit("stripe-form-change", changeEvent);
    },

    async submitHandler() {
      this.$emit("stripe-payment", this.stripeElement);
    },
    handleLoadError(event) {
      console.error("The stripe element failed to load.", JSON.stringify(event.error));
    },
  },

  mounted() {
    if (this.stripe && this.stripeOptions?.account) {
      const appearance = { theme: "stripe" };

      const locale = determine_locale(
        this.writtenLanguage,
        this.billing.country
      );

      const element = this.stripe.elements({
        locale,
        appearance,
        clientSecret: this.stripeOptions.clientSecret,
      });

      const paymentElement = element.create("payment", {
        defaultValues: {
          billingDetails: {
            email: this.billing.email,
            name: `${this.billing.firstName} ${this.billing.lastName}`,
            address:{
              country: countryCodeMappings[this.billing.country],
              city: this.billing.city,
              line1:this.billing.address1,
              postal_code: this.billing?.zip
            }
          },
        },

        business: {
          name: "Samsara",
        },
        fields: {
          billingDetails: {
            email: "auto",
            name: "auto",
            address: {
              country: "never",
            },
          },
        },
        wallets: {
          applePay: "never",
          googlePay: "never"
        }
      });

      this.stripeElement = element;

      paymentElement.addEventListener("change", this.verifyCompletedForm);

      paymentElement.on("loaderror", this.handleLoadError);

      paymentElement.mount("#payment-element");
    }
  },
  destroyed() {
    const element = this.stripeElement.getElement("payment");

    if (element) {
      element.removeEventListener("change", this.verifyCompletedForm);
    }
  },
};
</script>
